import styled from 'styled-components'

export const Container = styled.div`
    padding: 29px 0 0 0;
`